import { React } from 'react';

const StatisticsCard = ({value,label}) => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="display-4">{value}</div>
                <div className="text-muted">{label}</div>
            </div>
        </div>
    );
}

export default StatisticsCard;